/**
 * Modal component for content generation confirmation
 */

import React from 'react'
import { Modal, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import AttentionIcon from '../../../../assets/AttentionIcon.svg'
import WarningIcon from '../../../../assets/WarningIcon.svg'

const ConfirmationModal = ({
  visible,
  onOk,
  onCancel
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={t('v3:ai_popup_confirm_content')}
      visible={visible}
      centered
      onOk={onOk}
      onCancel={onCancel}
      className="ai-confirm-content"
      footer={[
        <Button
          key="back"
          onClick={onCancel}
          className="shl-secondary-btn"
        >
          {t('buttons:cancel')}
        </Button>,
        <Button
          key="submit"
          onClick={onOk}
          className="shl-primary-btn"
        >
          {t('v3:ai_Verify')}
        </Button>
      ]}
    >
      <div className="ai-warning">
        <div className="ai-warning-inner">
          <img
            src={AttentionIcon}
            alt="attention"
            className="attention-icon"
          />
          <h3>{t('v3:attention')}</h3>
        </div>
        <p>{t('v3:ai_undo_warning')}</p>
      </div>
      <div className="ai-check">
        <div className="ai-warning-inner">
          <img src={WarningIcon} alt="warning" className="warning-icon" />
          <h3>{t('v3:before_varifying')}</h3>
        </div>

        <p> {t('v3:ai_verified_content')}</p>
      </div>
      <div className="ai-proceed">{t('v3:ai_want_proceed')}</div>
    </Modal>
  )
}

export default ConfirmationModal
